// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referrer-title[data-v-ab3742ac]{cursor:pointer;color:#0d47a1}", ""]);
// Exports
module.exports = exports;
